import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { parseJSON } from '../../utils/apiHelper/apiHelper'
import { ContentStateInterface, ObjectParams } from '../../@types/types'
import { realEstateToApp } from '../realEstate/converters/toApp/realEstate'
import { ConvertedRealEstate, RealEstate } from '../../@types/real-estate-api-types'

export const findObjects: (
  defaultStateValues: ContentStateInterface,
  objectParams: ObjectParams
) => Promise<ConvertedRealEstate[] | undefined> = async (defaultStateValues, objectParams) => {
  const searchParams = new URLSearchParams()
  searchParams.append('type', objectParams.type)
  searchParams.append('transaction', objectParams.transaction)
  searchParams.append('segment', objectParams.segment)
  objectParams.buildingId && searchParams.append('buildingId', objectParams.buildingId)
  objectParams.unitId && searchParams.append('unitId', objectParams.unitId)

  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }

  const response = await customFetch(
    `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/objects?${searchParams}`,
    options
  )
  const result: RealEstate[] | null = await parseJSON(response)
  return result?.map((data) => realEstateToApp(data, defaultStateValues, objectParams.entryMode))
}
